<template>
    <div>
        <van-grid :border="false" :column-num="3">
            <van-grid-item v-for="(ele,index) in data" :key="index">
              <div class="num-wrapper" >
                <p class="num-p" @click="toList(ele)">{{commafy(ele.value)}}</p>
                <p class="ins-p">{{ele.text}}</p>
              </div>
            </van-grid-item>
          </van-grid>
    </div>
</template>
<script>
let userToken = localStorage.getItem("current_user_token");
import { numFormat } from "@/mixins/NumFormat.js";
export default {
    name: "dayAmount",
  components: {
  },
  data() {
    return {
      active: 0,
      data:[]
    };
  },
  mixins: [numFormat],
  computed: {},
  methods: {
    link: function(value) {
      location.href = "/" + value;
    },
    getQuantity() {
      this.$axios
        .post(this.$url + "/statistics", {
          userToken: userToken,
          askData: "dayAmount",
        })
        .then(response => {
          if (response.data.stat == "ok") {
            this.data = response.data.res_record;
            this.$emit('infoZero',this.data[0]['value']);
          } else {
            this.$toast(response.data.error_info);
          }
        })
        .catch(error => {
          this.$toast("网络无法连接或" + error);
        });
    },
    toList(value){
      if(value.text.indexOf('今日')!==-1){
        location.href = '/dayProjectList/'+0;
      }else{
        location.href = '/dayProjectList/'+1;
      }

    }
  },
  created() {
      this.getQuantity();
  }
    
}
</script>
<style scoped>

.num-wrapper {
  text-align: center;
}

.num-p {
  font-size: 1rem;
}

.ins-p {
  font-size: 0.5rem;
  color: #999;
  padding: 0.5rem 0;
}

</style>